// 模板名称
var list = {
	// 模板列表
	templateList: [{
			template_id: 0,
			name: "全部",
			en_name: "total",
			ad_match_type: 0,
			exchange_id: 0
		},
		{
			template_id: 60002,
			name: "开屏竖版图片1080*1920",
			en_name: "open screen vertical picture 1080*1920",
			ad_match_type: 1050000000045,
			exchange_id: 105
		},
		// {
		//   template_id: 20003,
		//   name: "信息流竖版图片360*640",
		//   en_name: "vertical picture of information flow 360*640",
		//   ad_match_type: 1050000000013,
		//   exchange_id: 105
		// },
		{
			template_id: 20005,
			name: "信息流横版图片1280*720",
			en_name: "horizontal picture of information flow 1280*720",
			ad_match_type: 0,
			exchange_id: 105
		},
		// {
		//   template_id: 20004,
		//   name: "信息流竖版图片640*960",
		//   en_name: "vertical picture of information flow 640*960",
		//   ad_match_type: 0,
		//   exchange_id: 105
		// },
		{
			template_id: 70001,
			name: "视频横版1280*720",
			en_name: "video horizontal version 1280*720",
			ad_match_type: 0,
			exchange_id: 105
		},
		{
			template_id: 10002,
			name: "视频竖版720*1280",
			en_name: "video vertical 720*1280",
			ad_match_type: 0,
			exchange_id: 105
		},
		{
			template_id: 80001,
			name: "OTT图片1920*1080",
			en_name: "OTT image 1920*1080",
			ad_match_type: 0,
			exchange_id: 105
		},
		{
			template_id: 80002,
			name: "OTT视频1920*1080",
			en_name: "OTT video 1920*1080",
			ad_match_type: 0,
			exchange_id: 105
		},
		{
			template_id: 80003,
			name: "OTT图片1280*720",
			en_name: "OTT image 1280*720",
		},
		{
			template_id: 80004,
			name: "OTT视频1280*720",
			en_name: "OTT video 1280*720",
		},
		{
			template_id: 90001,
			name: "暂停图片400*300",
			en_name: "pause picture 400*300",
		},
		{
			template_id: 11001,
			name: "角标图片300*100",
			en_name: "corner mark picture 300*100",
		},
		{
			template_id: 12001,
			name: "焦点图片640*320",
			en_name: "focus picture 640*320",
		},
		{
			template_id: 30001,
			name: "图标170*170",
			en_name: "icon170*170",
		},
		{
			template_id: 40001,
			name: "通栏710*120",
			en_name: "banner710*120",
		},
		{
			template_id: 50001,
			name: "插屏图片1080*1920",
			en_name: "inset picture 1080*1920",
		},
		{
			template_id: 99991,
			name: "图片",
			en_name: "picture",
		},
		{
			template_id: 99992,
			name: "图片",
			en_name: "picture",
		},
		{
			template_id: 99995,
			name: "图片",
			en_name: "picture",
		},
		{
			template_id: 99996,
			name: "视频",
			en_name: "video",
		},
	],
	// 合作模式
	modeList: [{
			id: 1,
			name: "pd",
			en_name: "pd",
		},
		{
			id: 2,
			name: "rtb",
			en_name: "rtb",
		},
		{
			id: 3,
			name: "分成",
			en_name: "divide into",
		},
	],
	// 合作地区
	areaList: [{
			id: 1,
			name: "国内",
			en_name: "China",
		},
		{
			id: 2,
			name: "其他",
			en_name: "other",
		},
	],
	// 流量类型
	flowTypeList: [{
			name: "信息流",
			en_name: "Information flow",
			id: 2,
			introduce: "APP推荐页、详情页中的原生图文或视频广告",
			in_en_name: "Native graphic or video advertisements in app recommendation and detail pages",
			show: true,
			template: [{
				template_id: 20005,
				name: "信息流横版图片1280*720",
				en_name: "horizontal picture of information flow 1280*720",
			},
			{
				template_id: 10002,
				name: "视频竖版720*1280",
				en_name: "video vertical version 720*1280",
			},
			{
				template_id: 70001,
				name: "视频横版1280*720",
				en_name: "video horizontal version 1280*720",
			}
		],
			style: [{
					id: "1",
					name: "左图右文",
					en_name: "Left picture right text",
					img: 'l_rimg.png'
				},
				{
					id: "2",
					name: "左文右图",
					en_name: "Left text and right picture",
					img: "r_limg.png"
				},
				{
					id: "3",
					name: "上图下文",
					en_name: "Figure below",
					img: "b_timg.png"
				},
				{
					id: "4",
					name: "上文下图",
					en_name: "Above and below",
					img: "t_bimg.png"
				},
			]
		},
		{
			name: "开屏",
			en_name: "Open screen",
			id: 1,
			introduce: "流量APP开机画面展示的广告",
			in_en_name: "Advertisements displayed on the startup screen of the traffic app",
			show: true,
			template: [{
				template_id: 60002,
				name: "开屏竖版图片1080*1920",
				en_name: "open screen vertical picture 1080*1920",
			}],
			abroad_template: [{
				template_id: 99995,
				name: "图片",
				en_name: "picture",
			}],
			style: [{
					id: "5",
					name: "开屏全屏",
					en_name: "Open screen full screen",
					img: 'full.png'
				},
				{
					id: "6",
					name: "开屏半屏",
					en_name: "Open screen half screen",
					img: "half.png"
				},
			]
		},
		{
			name: "Banner",
			en_name: "Banner",
			id: 4,
			introduce: "APP界面顶部、中部或底部展现的多形态广告样式",
			in_en_name: "Multi form advertising styles displayed at the top, middle, or bottom of the APP interface",
			show: true,
			template: [{
				template_id: 40001,
				name: "通栏710*120",
				en_name: "banner710*120",
			}],
			abroad_template: [{
				template_id: 99991,
				name: "图片",
				en_name: "picture",
			}],
			size: [{
					size_id: 9666201,
					name: "Banner320*50",
					en_name: "Banner320*50",
				},
				{
					size_id: 9666202,
					name: "Banner300*250",
					en_name: "Banner300*250",
				},
				{
					size_id: 9666203,
					name: "Banner300*50",
					en_name: "Banner300*50",
				},
				{
					size_id: 9666204,
					name: "Banner250*250",
					en_name: "Banner250*250",
				},
				{
					size_id: 9666205,
					name: "Banner320*100",
					en_name: "Banner320*100",
				},
				{
					size_id: 9666206,
					name: "Banner728*90",
					en_name: "Banner728*90",
				},
			],
			style: [{
				id: "7",
				name: "Banner",
				en_name: "Banner",
				img: 'banner.png'
			}, ]
		},
		{
			name: "插屏",
			en_name: "Table plaque",
			id: 3,
			introduce: "APP内容中使用场景切换时弹出窗口上展示的广告",
			in_en_name: "Advertisements displayed on pop-up windows during scene switching in app content",
			show: true,
			template: [{
				template_id: 50001,
				name: "插屏图片1080*1920",
				en_name: "inset picture 1080*1920",
			}],
			abroad_template: [{
				template_id: 50001,
				name: "插屏图片1080*1920",
				en_name: "inset picture 1080*1920",
			}],
			style: [{
				id: "8",
				name: "插屏",
				en_name: "Table plaque",
				img: 'insert.png'
			}, ]
		},
		{
			name: "激励视频",
			en_name: "Motivation video",
			id: 7,
			introduce: "用户选择观看视频广告来换取应用或游戏内的奖励",
			in_en_name: "Users choose to watch video advertisements in exchange for in-app or in-game rewards",
			show: true,
			template: [{
					template_id: 10002,
					name: "视频竖版720*1280",
					en_name: "video vertical version 720*1280",
				},
				{
					template_id: 70001,
					name: "视频横版1280*720",
					en_name: "video horizontal version 1280*720",
				},
			],
			abroad_template: [{
				template_id: 99996,
				name: "视频",
				en_name: "video",
			}],
			size: [{
					size_id: 9666101,
					name: "激励视频竖版720*1280",
					en_name: "Motivation video vertical 720*1280",
				},
				{
					size_id: 9666102,
					name: "激励视频横版1280*720",
					en_name: "Motivation video horizontal 1280*720",
				},
			],
			style: [{
					id: "9",
					name: "竖版视频",
					en_name: "Vertical video",
					img: 'vertical.png'
				},
				{
					id: "10",
					name: "横版视频",
					en_name: "Horizontal video",
					img: 'horizontal.png'
				},
			]
		},
		{
			name: "角标",
			en_name: "Corner mark",
			id: 5,
			introduce: "在APP的特定角落位置出现的小幅广告",
			in_en_name: "Small advertisements appearing in specific corners of the app",
			show: true,
			template: [{
				template_id: 11001,
				name: "角标图片300*100",
				en_name: "corner mark picture 300*100",
			}],
			style: [{
				id: "11",
				name: "角标",
				en_name: "Corner",
				img: 'corner.png'
			}, ]
		},
		{
			name: "暂停广告",
			en_name: "Pause advertising",
			id: 8,
			introduce: "在用户暂停播放视频或游戏时出现的广告",
			in_en_name: "Advertisements that appear when users pause playing videos or games",
			show: true,
			template: [{
				template_id: 90001,
				name: "暂停图片400*300",
				en_name: "pause picture 400*300",
			}],
			style: [{
				id: "12",
				name: "暂停广告",
				en_name: "Pause advertising",
				img: 'pause.png'
			}, ]
		},
		{
			name: "焦点图",
			en_name: "Focus picture",
			id: 9,
			introduce: "通常出现在APP的首页，通过轮播的形式展示多个广告或信息",
			in_en_name: "Usually appearing on the homepage of an app, displaying multiple advertisements or information in a rotating format",
			show: true,
			template: [{
				template_id: 12001,
				name: "焦点图片640*320",
				en_name: "focus picture 640*320",
			}],
			style: [{
				id: "13",
				name: "焦点图",
				en_name: "Focus picture",
				img: 'focus.png'
			}, ]
		},
		{
			name: "图标",
			en_name: "Icon",
			id: 6,
			introduce: "在APP中的小图标，用户点击图标可以连接到指定的广告页面或信息",
			in_en_name: "The small icon in the app allows users to connect to a specified advertising page or information by clicking on the icon",
			show: true,
			template: [{
				template_id: 30001,
				name: "图标170*170",
				en_name: "icon170*170",
			}],
			style: [{
				id: "14",
				name: "图标",
				en_name: "Icon",
				img: 'icon.png'
			}, ]
		},
		{
			name: "OTT",
			en_name: "OTT",
			id: 10,
			introduce: "通过连接到互联网的电视设备（如智能电视或流媒体播放器）播放的在线广告",
			in_en_name: "Online advertisements played through TV devices connected to the internet, such as smart TVs or streaming players",
			show: true,
			template: [{
					template_id: 80001,
					name: "OTT图片1920*1080",
					en_name: "OTT image 1920*1080",
				},
				{
					template_id: 80002,
					name: "OTT视频1920*1080",
					en_name: "OTT video 1920*1080",
				},
				{
					template_id: 80003,
					name: "OTT图片1280*720",
					en_name: "OTT image 1280*720",
				},
				{
					template_id: 80004,
					name: "OTT视频1280*720",
					en_name: "OTT video 1280*720",
				},
			],
			style: [{
				id: "15",
				name: "OTT",
				en_name: "OTT",
				img: 'ott.png'
			}, ]
		},
		{
			name: "Native",
			en_name: "Native",
			id: 11,
			introduce: "内容风格与页面一致，符合用户使用原页面行为习惯的广告",
			in_en_name: "The content style is consistent with the page, in line with the user's behavior habits of using the original page",
			show: true,
			abroad_template: [{
				template_id: 99992,
				name: "图片",
				en_name: "picture",
			}, ],
			size: [{
				size_id: 9666301,
				name: "Native",
				en_name: "Native",
			}, ],
			style: [{
					id: "1",
					name: "左图右文",
					en_name: "Left picture right text",
					img: 'l_rimg.png'
				},
				{
					id: "2",
					name: "左文右图",
					en_name: "Left text and right picture",
					img: "r_limg.png"
				},
				{
					id: "3",
					name: "上图下文",
					en_name: "Figure below",
					img: "b_timg.png"
				},
				{
					id: "4",
					name: "上文下图",
					en_name: "Above and below",
					img: "t_bimg.png"
				},
			]
		}
	],
	// 设备类型
	deviceList: [{
			id: 1,
			name: "IMEI",
			os_type: 1,
		},
		{
			id: 2,
			name: "OAID",
			os_type: 1,
		},
		{
			id: 3,
			name: "IDFA",
			os_type: 2,
		},
		{
			id: 4,
			name: "IMEI-MD5",
			os_type: 1,
		},
		{
			id: 5,
			name: "OAID-MD5",
			os_type: 1,
		},
		{
			id: 6,
			name: "IDFA-MD5",
			os_type: 2,
		},
		{
			id: 7,
			name: "GAID",
			os_type: 1,
		},
		{
			id: 8,
			name: "ANDROIDID",
			os_type: 1,
		},
	],
	// 广告交互类型  1落地页,2DP,3下载
	interactiveList: [{
			id: 1,
			name: "落地页",
			en_name: "landing page",
		},
		{
			id: 2,
			name: "DP唤醒",
			en_name: "DP wake-up",
		},
		{
			id: 3,
			name: "下载",
			en_name: "download",
		},
	],
	// 样式配置-平台渲染-样式选择
	styleList: [{
			id: 1,
			name: "左图右文",
			en_name: "Left picture right text"
		},
		{
			id: 2,
			name: "左文右图",
			en_name: "Left text and right picture"
		},
		{
			id: 3,
			name: "上文下图",
			en_name: "Figure below"
		},
		{
			id: 4,
			name: "上图下文",
			en_name: "Above and below"
		},
	],
	// 样式配置-自渲染-元素配置
	elementsList: [{
			label: 'img',
			name: '图片',
			en_name: 'image',
			showType: 0
		},
		{
			label: 'cover',
			name: '封面',
			en_name: 'cover',
			showType: 7
		},
		{
			label: 'video',
			name: '视频',
			en_name: 'video',
			showType: 7
		},
		{
			label: 'title',
			name: '标题',
			en_name: 'title',
			showType: 0
		},
		{
			label: 'desc',
			name: '描述',
			en_name: 'description',
			showType: 0
		},
		{
			label: 'icon',
			name: 'icon',
			en_name: 'icon',
			showType: 0
		},
		{
			label: 'product',
			name: '品牌名称',
			en_name: 'brand name',
			showType: 0
		},
		{
			label: 'button',
			name: '按钮文案',
			en_name: 'button copy',
			showType: 0
		}
	],
	yesOrNo: [{
			id: 1,
			name: '是',
			en_name: 'yes'
		},
		{
			id: 0,
			name: '否',
			en_name: 'no'
		},
	],


	// 海外通用参数
	abroadList: {
		
		// 合作模式
		modeList: [{
				id: 1,
				name: "Flat-CPM",
				en_name: "Flat-CPM",
			},
			{
				id: 2,
				name: "Client bidding",
				en_name: "Client bidding",
			},
		],
		
		// 广告类型-开屏广告
		flowTypeOpenAd: [{
			name: "开屏",
			en_name: "Splash",
			id: 1,
			introduce: "流量APP开机画面展示的广告",
			in_en_name: "Advertisements displayed on the startup screen of the traffic app",
			show: true,
			abroad_template: [{
				template_id: 99995,
				name: "图片",
				en_name: "picture",
			}],
			style: [{
					id: "5",
					name: "开屏全屏",
					en_name: "Open screen full screen",
					img: 'full.png'
				},
				{
					id: "6",
					name: "开屏半屏",
					en_name: "Open screen half screen",
					img: "half.png"
				},
			]
		}, ],
		// 广告类型
		flowTypeList: [{
				name: "Banner",
				en_name: "Banner",
				id: 4,
				introduce: "APP界面顶部、中部或底部展现的多形态广告样式",
				in_en_name: "Multi form advertising styles displayed at the top, middle, or bottom of the APP interface",
				show: true,
				abroad_template: [{
					template_id: 99991,
					name: "图片",
					en_name: "picture",
				}],
				size: [{
						size_id: 9666201,
						name: "Banner320*50",
						en_name: "Banner320*50",
					},
					{
						size_id: 9666202,
						name: "Banner300*250",
						en_name: "Banner300*250",
					},
					{
						size_id: 9666203,
						name: "Banner300*50",
						en_name: "Banner300*50",
					},
					{
						size_id: 9666204,
						name: "Banner250*250",
						en_name: "Banner250*250",
					},
					{
						size_id: 9666205,
						name: "Banner320*100",
						en_name: "Banner320*100",
					},
					{
						size_id: 9666206,
						name: "Banner728*90",
						en_name: "Banner728*90",
					},
				],
				style: [{
					id: "7",
					name: "Banner",
					en_name: "Banner",
					img: 'banner.png'
				}, ]
			},
			{
				name: "插屏",
				en_name: "Interstitial",
				id: 3,
				introduce: "流量APP开机或APP内弹出的全屏广告，图片视频混出，5S后可点击关闭",
				in_en_name: "Full-screen advertisements displayed during app startup or scene transitions, closable after 5 seconds",
				show: true,
				abroad_template: [{
					template_id: 99995,
					name: "插屏图片",
					en_name: "inset picture",
				}],
				style: [{
					id: "8",
					name: "插屏",
					en_name: "Table plaque",
					img: 'full.png'
				}, ]
			},
			{
				name: "激励视频",
				en_name: "Rewarded Video",
				id: 7,
				introduce: "用户选择观看视频广告来换取应用或游戏内的奖励",
				in_en_name: "Users choose to watch video advertisements in exchange for in-app or in-game rewards",
				show: true,
				abroad_template: [{
					template_id: 99996,
					name: "视频",
					en_name: "video",
				}],
				size: [{
						size_id: 9666101,
						name: "激励视频竖版720*1280",
						en_name: "Motivation video vertical 720*1280",
					},
					{
						size_id: 9666102,
						name: "激励视频横版1280*720",
						en_name: "Motivation video horizontal 1280*720",
					},
				],
				style: [{
						id: "9",
						name: "竖版视频",
						en_name: "Vertical video",
						img: 'vertical.png'
					},
					{
						id: "10",
						name: "横版视频",
						en_name: "Horizontal video",
						img: 'horizontal.png'
					},
				]
			},
			{
				name: "Native",
				en_name: "Native",
				id: 11,
				introduce: "内容风格与页面一致，符合用户使用原页面行为习惯的广告",
				in_en_name: "The content style is consistent with the page, in line with the user's behavior habits of using the original page",
				show: true,
				abroad_template: [{
					template_id: 99992,
					name: "图片",
					en_name: "picture",
				}, ],
				size: [{
					size_id: 9666301,
					name: "Native",
					en_name: "Native",
				}, ],
				style: [{
						id: "1",
						name: "左图右文",
						en_name: "Left picture right text",
						img: 'l_rimg.png'
					},
					{
						id: "2",
						name: "左文右图",
						en_name: "Left text and right picture",
						img: "r_limg.png"
					},
					{
						id: "3",
						name: "上图下文",
						en_name: "Figure below",
						img: "b_timg.png"
					},
					{
						id: "4",
						name: "上文下图",
						en_name: "Above and below",
						img: "t_bimg.png"
					},
				]
			}
		],
		// 设备类型
		deviceList: [

			{
				id: 3,
				name: "IDFA",
				os_type: 2,
			},
			{
				id: 7,
				name: "GAID",
				os_type: 1,
			},
		],
		
		yesOrNo: [{
				id: 1,
				name: '是',
				en_name: 'yes'
			},
			{
				id: 0,
				name: '否',
				en_name: 'no'
			},
		],
		statusList: [
			// 审核状态改为状态
			// 待审核、审核通过、审核拒绝-->开启、暂停；
			{
				id: 1,
				name: '暂停',
				en_name: 'Pause',
				type: 'danger',
				color: '#DD2A4D'
			},
			{
				id: 2,
				name: '开启',
				en_name: 'Start',
				type: 'success',
				color: '#0EAC01'
			}
			// {
			// 	id: 1,
			// 	name: '待审核',
			// 	en_name: 'Pending Review',
			// 	type: 'warning',
			// 	color: '#FF8900'
			// },
			// {
			// 	id: 2,
			// 	name: '审核通过',
			// 	en_name: 'Approved',
			// 	type: 'success',
			// 	color: '#0EAC01'
			// },
			// {
			// 	id: 3,
			// 	name: '审核驳回',
			// 	en_name: 'Rejected',
			// 	type: 'danger',
			// 	color: '#DD2A4D'
			// },
		]
	}
}

export default list